const proyecto = {
  createMapa: 'proyecto',
  createMapaClonar: 'proyecto/{{uuid_proyecto}}/clonar',
  createProyecto: 'proyecto',
  createProyectoClonar: 'proyecto/{{uuid_proyecto}}/clonar',
  deleteProyecto: 'proyecto/{{uuid_proyecto}}',
  readComentario: 'comentario/{{uuid_comentario}}',
  readProyecto: 'proyecto/{{uuid_proyecto}}',
  readProyectoCategorias: 'proyecto/categoria',
  readProyectoComentarios: 'comentarios/proyecto/{{uuid_proyecto}}/tipo',
  readProyectoProgresoAlumnos: 'proyecto/{{uuid_proyecto}}/progreso-alumnos',
  readProyectos: 'proyectos',
  readProyectosByAcademia: 'academia/{{uuid_academia}}/proyectos',
  updateProyecto: 'proyecto/{{uuid_proyecto}}',
  updateProyectosOrdenar: 'proyectos/ordenar'
}

export default proyecto
